import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { HttpService } from '../services/http.service';

@Injectable()
export class ExchangeRateService {
    private httpService = inject(HttpService);

    private _euro$ = new BehaviorSubject<number | null>(null);

    euro$ = this._euro$.pipe(filter((rate) => rate !== null));

    private subscription$ = new Subscription();

    dispatch(): void {
        this.subscription$.add(
            this.httpService
                .getEuroExchangeRate()
                .pipe(tap((rate) => this._euro$.next(rate)))
                .subscribe(),
        );
    }

    destroy(): void {
        this.subscription$.unsubscribe();
    }
}
